import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchUsers(params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value));
    }
  });

  const suffix = query.toString() ? `?${query.toString()}` : '';
  const res = await apiFetch(`${API_BASE}/admin/user${suffix}`);
  return res.json();
}

export async function updateUser(userId, colValues) {
  const res = await apiFetch(`${API_BASE}/admin/user/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(colValues)
  });
  return res.json();
}
